import { ResponseError } from 'shared/common/errors';
import { TGetInfrastructureGeoObjectsResponse } from 'shared/common/repositories/infrastructure-caching/v1/get-infrastructure-geo-objects';
import { IInfrastructureGeoObjectsResponse } from 'shared/common/repositories/infrastructure-caching/entities/infrastructure/InfrastructureGeoObjectsResponse';

export function assertFetchGetInfrastructureGeoObjectsResponse(
  response: TGetInfrastructureGeoObjectsResponse,
): asserts response is { statusCode: 200; response: IInfrastructureGeoObjectsResponse } {
  if (response.statusCode !== 200) {
    throw new ResponseError({
      message: response.response.message || 'Unknown error',
      domain: 'assertFetchGetInfrastructureGeoObjectsResponse',
    });
  }
}
